module.exports = __webpack_public_path__ + "img/diamante-ii.0ae63a35.png";